import { Component, computed, inject } from '@angular/core';
import {
  RegionItemDto,
  TeamFilterDto,
  TeamItemDto,
  TeamService,
} from '@artemis-software/wr-api';
import { currentTenantId } from '@/utils/admin-utils';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CurrentUserService } from '@services/current-user.service';

@Component({
  standalone: false,
  selector: 'wr-team-overview-page',
  templateUrl: './team-overview-page.component.html',
  styleUrls: ['./team-overview-page.component.scss']
})
export class TeamOverviewPageComponent {
  teamService = inject(TeamService);
  currentUserService = inject(CurrentUserService);
  tenantId = currentTenantId();
  canCreate = computed(() => this.currentUserService.hasPrivilege('canCreateTeams'));

  readonly loadTeams = (filter: TeamFilterDto) => this.teamService.findAll({ ...filter, tenantId: this.tenantId() });
  readonly getCount = (filter: TeamFilterDto) => this.teamService.getCount({ ...filter, tenantId: this.tenantId() });

  form!: FormGroup;

  constructor(private readonly router: Router,
              private readonly formBuilder: FormBuilder,)
  {
    this.form = this.formBuilder.group({
      text: this.formBuilder.control(''),
      region: this.formBuilder.control<RegionItemDto | null>(null),
      regionId: this.formBuilder.control<string | null>(null),
    });

    this.form.get('region')?.valueChanges.subscribe((region) => {
      if (region) {
        this.form.get('regionId')?.setValue(region.id);
      } else {
        this.form.get('regionId')?.setValue(null);
      }
    });
  }

  navigateToTeam(team: TeamItemDto): void {
    this.router.navigate(['team', team.id]);
  }

  add(): void {
    this.router.navigate(['team', 'new']);
  }
}
